export default __webpack_public_path__ + "static/media/new-session-example.98855167.jpg";